<template @click="setDialogFilterTag(true)">
  <v-row justify="center">
    <v-dialog fullscreen v-model="dialogFilterTag" hide-overlay>
      <template v-slot:activator="{ on }">

        <v-btn class="px-0 mx-0 pt-0 pb-0" text icon big v-on="on">
          <v-badge bordered overlap class="px-0 mx-0" style="white-space:nowrap" overlapcolor="green"
            :content="listOfSelectedTag.length" v-if="listOfSelectedTag.length>0">
            <v-img style="width:3rem" :contain="true" :src="require('@/assets/filter.png')">
            </v-img>
          </v-badge>
          <span style="white-space:nowrap" v-else>
            <v-img style="width:3rem" :contain="true" :src="require('@/assets/filter.png')">
            </v-img>
          </span>
        </v-btn>

        <!--v-btn v-if="$route.name=='map'" class="px-0 mx-0" text big @click="gotopage('/home')">
                <i class=" mdi mdi-view-module"></i> {{ $t("list") }}
              </!--v-btn-->

      </template>
      <v-card>
        <v-container class="pt-0">
          <v-row class="text-center pt-0">
            <v-col cols=3>
            </v-col>
            <v-col cols=6>
              <span class="selectInterestTitle"><i class=" mdi mdi-filter"></i> {{ $t("Filter") }}</span>
            </v-col>
            <v-col cols=3>
            </v-col>
          </v-row>
          <v-row class="text-center">
            <v-col cols="12" class="pt-0 mt-0">
              <v-row v-if="refreshComponent" justify="space-around" mt-auto>
                <v-col @click="selectPreferences(tag.id)" class="squareTag px-0 mx-0 pt-0 pb-0 mt-2" align="center"
                  justify="center" :style="calcTagPreferenceStyle(tag.selected)" v-for="(tag, i) in tagArray" :key="i">
  
                  <v-container v-if="tag" fill-height fluid class="squareTag px-2 mx-0 pt-0 pb-0 mt-0">
                    <v-row lign="center" justify="center">
                      <v-col class="px-0 px-0 titlePreference">{{$t(tag.tag)}}</v-col>
                    </v-row>
                  </v-container>

                </v-col>
                <v-footer absolute class="font-weight-medium mt-3">
                  <v-row>
                    <v-col class="text-center" cols="5">
                      <v-btn text @click="clearAllTags()">
                        {{$t("clearAll")}}
                      </v-btn>
                    </v-col>
                    <v-col class="text-center" cols="1">

                    </v-col>
                    <v-col class="text-center" cols="3">
                      <v-btn text @click="skipPreference()">
                        {{$t("back")}}
                      </v-btn>
                    </v-col>
                    <v-col class="text-center" cols="3">
                      <v-btn text @click="savePreferences()">
                        {{$t("save")}}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-footer>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
//import { mapState } from 'vuex';
export default ({
  name: 'modalFilter',

  data: () => ({
    apiUrl: process.env.VUE_APP_ROOT_API,
    tagArray: [],
    listOfSelectedTag: [],
    refreshComponent: true
  }),
  computed: {
      //information of the logged in user
      //contains the user's position taken from the db
    getUser: {
        get: function () {
          return this.$store.getters.getUser;
        }
      },
//      ...mapState(['dialogFilterTag']),
    dialogFilterTag: {
      get(){
        return this.$store.state.dialogFilterTag;
      },
      set(value){
        this.$store.dispatch('setDialogFilterTag',value)
      }
    }
,
    userHasSkippedFilterTag: function(){
        return this.$store.state.userHasSkippedFilterTag;
    }
  },
  async mounted() {
    await this.getListOfTagArray()
    await this.readFromStorelistOfSelectedTag()
    if (this.$store.getters.getListOfSelectedTag.length > 0) {
      this.setUserPreferenceTag()
    }

    //this.filterTagBasedOnUser()
  },

  methods: {
    //each user see different tag based on conuntry
        //check user default country
    /*filterTagBasedOnUser: function () {

    var filtered = [];
     this.tagArray.forEach((item,index)=>{
      if (item.languages!=null&&item.languages.includes(this.getUser.language)) {
          filtered.push(this.tagArray[index]);
      }
    })
    this.tagArray= filtered
    },*/

//clear all tags and close dialog
    clearAllTags(){
      this.tagArray.forEach(function(v){ delete v.selected })
      this.savePreferences()
    },

//if user is logged for the first time, can press skip filter
    skipPreference(){
      this.dialogFilterTag = false
      this.$store.dispatch('setUserHasSkippedFilterTag',true)
      //this.$store.dispatch('setDialogFilterTag',false)
    },

//set the dialog filter tag show or hide
    setDialogFilterTag: function (value) {
      //console.log('setDialogFilterTag',value)
      this.$store.dispatch('setDialogFilterTag',value)
    },
//assign to each tag the css style based on the selection
    calcTagPreferenceStyle: function (value) {
      if (value == true) {
        return 'background:  #81B9BF'
      } else {
        return 'border: #81B9BF solid 2px;'
      }
    },
//reads the list of selected tags from the store
    readFromStorelistOfSelectedTag() {
      this.listOfSelectedTag = this.$store.getters.getListOfSelectedTag
    },
    //method that reads a string of strings with tags previously saved by a user and
    //it cycles the array of selectable tagged objects to set the tags previously saved by the user to true
    async setUserPreferenceTag() {
      try {
        this.tagArray.forEach((e, index) => {
          if (this.listOfSelectedTag.includes(e.tag)) {
            this.tagArray[index].selected = true;
          }
        })
      } catch (error) {
        console.log(error);
      }
    },
    //get the tags list from db
    async getListOfTagArray() {
      try {
        let completeurl = this.apiUrl + '/getTags'
        this.tagArray = await this.getaxiosResponse(completeurl)
        this.tagArray = this.tagArray.data
      } catch (error) {
        console.log(error);
      }
    },
    //routing to change the page
    gotopage: function (page) {
      if (this.$router.history.current.path != page) {
        this.$router.push(page)
      }
    },
    savePreferences() {
      this.listOfSelectedTag = []
      this.tagArray.forEach((e) => {
        if (e.selected == true)
          this.listOfSelectedTag.push(e.tag)
      })
      this.$store.dispatch('setListOfSelectedTag', this.listOfSelectedTag)
      this.dialogFilterTag = false
    },
    selectPreferences(selectedID) {
      this.refreshComponent = false
      this.tagArray.forEach((item, i) => {
        if (item.id == selectedID) {
          this.tagArray[i].selected = !this.tagArray[i].selected
        }
      })
      this.refreshComponent = true
    }
  }
})
</script>

<style>
.squareTag{
max-height: 5.5rem;
min-width: 5.5rem;
max-width: 5.5rem;
min-height: 5.5rem;
}
.stylepreferencebtn{
height: 12vh;
width: 12vh;
}
.titlePreference{
    font-size: 0.6rem;
    text-transform: uppercase;
}
.v-card{
  overflow-wrap: inherit;
}
.selectInterestTitle{
font-size: 1.2rem;
}
.mdi.mdi-filter-outline{
  font-size: 1.4rem;;
}
</style>